import "components/Flow/Flow.css";

import CampaignPathwayNode from "./CampaignPathwayNode";

export const nodeTypes = {
  campaignPathwayNode: CampaignPathwayNode,
};